import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { Trash } from 'lucide-react';
import type { FC } from 'react';

interface DeleteRowConfirmModalProps {
  rowName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting?: boolean;
  onConfirm: () => void;
}

export const DeleteRowConfirmModal: FC<DeleteRowConfirmModalProps> = ({
  rowName,
  open,
  onOpenChange,
  isDeleting,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete row?</DialogTitle>
          <DialogDescription>
            <Text variant="body-sm" color="primary">
              All extracted data for <strong>{rowName}</strong> will be lost.
              This action can not be undone. Are you sure you want to continue?
            </Text>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            <Trash />
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
